/**
 * following class names are used as DOM selectors outside of react, please don't remove them
 * and if moving HTML around make sure to update accordingly
 */
export const STATIC_BREADCRUMBS_SELECTOR_CLASSNAMES = {
    ITEM: 'breadcrumb-item',
    ITEM_LAST: 'breadcrumb-item-last',
};
